import {PickedGiftsPayload} from '@/store/gifts-cart/gifts-cart.utils';
import {AvailableGifts} from '__generated__/__types__';

type Action =
    | {type: 'SET_PICKED_GIFTS_PAYLOAD'; productId: number; pickedGiftsPayload: PickedGiftsPayload}
    | {type: 'CHANGE_PICKED_GIFTS_PAYLOAD'; pickedGiftsPayload: PickedGiftsPayload}
    | {type: 'CHANGE_PRODUCT_ID'; productId: number}
    | {type: 'RESET_GIFT_CART_STATE'}
    | {type: 'SET_IS_ADDING_GIFT_TO_CART'; isLoading: boolean}
    | {type: 'SET_AVAILABLE_GIFTS'; availableGifts: AvailableGifts[]}
    | {type: 'REMOVE_AVAILABLE_GIFTS'; cartItemId: number}
    | {type: 'SET_IS_GETTING_AVAILABLE_GIFTS'; isLoading: boolean};

export interface GiftsCartState {
    productId?: number;
    pickedGiftsPayload: PickedGiftsPayload;
    isAddingGiftToCart: boolean;
    availableGiftsInCart: AvailableGifts[];
    isGettingAvailableGifts: boolean;
}

export const initialState: GiftsCartState = {
    pickedGiftsPayload: {},
    isAddingGiftToCart: false,
    availableGiftsInCart: [],
    isGettingAvailableGifts: false,
};

export function giftsCartReducer(state: GiftsCartState, action: Action): GiftsCartState {
    switch (action.type) {
        case 'SET_PICKED_GIFTS_PAYLOAD': {
            return {
                ...state,
                productId: action.productId,
                pickedGiftsPayload: action.pickedGiftsPayload,
            };
        }
        case 'CHANGE_PICKED_GIFTS_PAYLOAD': {
            return {
                ...state,
                pickedGiftsPayload: action.pickedGiftsPayload,
            };
        }
        case 'CHANGE_PRODUCT_ID': {
            return {
                ...state,
                productId: action.productId,
            };
        }
        case 'SET_IS_ADDING_GIFT_TO_CART': {
            return {
                ...state,
                isAddingGiftToCart: action.isLoading,
            };
        }
        case 'SET_AVAILABLE_GIFTS': {
            const updatedAvailableGiftsInCart = [...action.availableGifts];
            return {
                ...state,
                availableGiftsInCart: updatedAvailableGiftsInCart,
            };
        }
        case 'REMOVE_AVAILABLE_GIFTS': {
            const currentAvailableGiftsInCart = [...state.availableGiftsInCart];
            const updatedAvailableGiftsInCart = currentAvailableGiftsInCart.filter(
                item => item?.cart_item_id !== action.cartItemId,
            );
            return {
                ...state,
                availableGiftsInCart: updatedAvailableGiftsInCart,
            };
        }
        case 'SET_IS_GETTING_AVAILABLE_GIFTS': {
            return {
                ...state,
                isGettingAvailableGifts: action.isLoading,
            };
        }
        case 'RESET_GIFT_CART_STATE':
            return initialState;
        default:
            return state;
    }
}
